import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_mountain_green/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-c31ee62f98.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-02500410b8.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-c408566b83.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-70adb113b5.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-8251e6cc6e.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-c4efab01ba.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-94702ed381.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-b9b6e00e13.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-82e940a2aa.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-c0d3a92ba4.png'; };
